import { apiSlice } from './apiSlice';
import type {
  ScenarioDryRunResponse,
  ScenarioGeneratorRequest,
  ScenarioPublishResponse,
} from '../types/scenarioSpec';

/**
 * Authoring-слой сценариев (`/api/scenario-generator`, admin-gated 'users.update').
 *
 * `publish` — ЕДИНСТВЕННЫЙ путь записи в таблицу `scenario_templates`, то есть
 * единственный способ добавить сценарий в игровую галерею (`GET /api/scenarios`).
 * До появления этого слайса фронт вообще не звал генератор, поэтому каталог в БД
 * стоял на двух строках из liquibase-baseline, а семь канонических сценариев
 * жили только в backend-сидах и Unity-бандле.
 *
 * Идемпотентность: publish ключуется по (slug, sourceSpecHash, generatorVersion,
 * engineVersion) — повторная публикация того же spec вернёт 200 + idempotent:true,
 * а не создаст новую версию.
 */
export const scenarioAdminApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    dryRunScenarioSpec: build.mutation<ScenarioDryRunResponse, ScenarioGeneratorRequest>({
      query: ({ spec, visibility = 'draft', generationPolicy }) => ({
        url: '/scenario-generator/dry-run',
        method: 'POST',
        body: { spec, visibility, ...(generationPolicy ? { generationPolicy } : {}) },
      }),
    }),
    publishScenarioSpec: build.mutation<ScenarioPublishResponse, ScenarioGeneratorRequest>({
      query: ({ spec, visibility = 'draft', generationPolicy }) => ({
        url: '/scenario-generator/publish',
        method: 'POST',
        body: { spec, visibility, ...(generationPolicy ? { generationPolicy } : {}) },
      }),
      invalidatesTags: [{ type: 'ScenarioTemplate' as const, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useDryRunScenarioSpecMutation,
  usePublishScenarioSpecMutation,
} = scenarioAdminApi;
